import React from 'react';
import { Button } from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';

export default function BackButton({ defaultPath }) {
  const history = useHistory();
  const location = useLocation();


  const handlePushBack = () => {
    const params = new URLSearchParams(location.search);
    const page = params.get('page');
    const size = params.get('size');
    if (defaultPath) {
      if (page) {
        history.push(`${defaultPath}?page=${page}&size=${size}`);
      } else {
        history.push(defaultPath);
      }
    } else {
      history.goBack();
    }
  };

  return (
    <Button variant="outlined" onClick={handlePushBack}>
      กลับ
    </Button>
  );
}